export default function (el) {
    const boxes = ['box1', 'box12', 'box13'];
    const getScale = function () {
        return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--scale')) || 1;
    }


    const in1 = document.getElementById('in1');
    const in2 = document.getElementById('in2');
    const layouts = document.getElementById('layouts');
    const measureEl = document.getElementById('measure');
    let tema = 1;

    // máximos de fonte por preview
    const maxFonts = {
        line1: 30, line2: 24, line3: 20, line4: 20
    };



    const fitFontSize = function (text, box, maxFont, fontWeight = 700, fontFamily = 'Inter', allowWrap = false, extraOffset = { left: 0, top: 0 }) {
        const scaleFactor = getScale();

        measureEl.style.fontWeight = fontWeight;
        measureEl.style.fontFamily = fontFamily;
        measureEl.style.fontSize = (maxFont * scaleFactor) + 'px'; // aplica escala
        measureEl.style.opacity = '0';
        measureEl.style.pointerEvents = 'none';
        measureEl.style.position = 'absolute';
        measureEl.style.lineHeight = '1';

        let displayText = text || '';
        if (allowWrap) {
            displayText = displayText.replace(/\s/, '\n'); // força quebra no primeiro espaço
            measureEl.style.whiteSpace = 'pre-line';
            measureEl.style.wordBreak = 'keep-all';
        } else {
            measureEl.style.whiteSpace = 'nowrap';
            measureEl.style.wordBreak = 'normal';
        }
        measureEl.textContent = displayText;

        const boxRect = box.getBoundingClientRect();
        const lineBox = box.querySelector('.line-box');
        const cs = getComputedStyle(lineBox);
        const padL = parseFloat(cs.paddingLeft) || 0;
        const padR = parseFloat(cs.paddingRight) || 0;
        const padT = parseFloat(cs.paddingTop) || 0;
        const padB = parseFloat(cs.paddingBottom) || 0;
        const safeMargin = 12;

        const availW = boxRect.width - (padL + padR) - safeMargin * 2 - (extraOffset.left || 0);
        const availH = boxRect.height - (padT + padB) - (extraOffset.top || 0);

        const textRect = measureEl.getBoundingClientRect();
        const scaleW = availW / textRect.width;
        const scaleH = availH / textRect.height;
        const scale = Math.min(scaleW, scaleH, 1);

        return Math.max(8, (maxFont * scaleFactor) * scale);
    }


    const update = function () {
        const line1 = (in1.value || 'Nome Sobrenome').trim();
        const line2 = (in2.value || 'Minha classe').trim();
        const line3 = (in3.value || 'Minha escola').trim();
        const line4 = (in4.value || 'Meu contato').trim();

        // Preview 1
        const box1 = document.getElementById('box1');
        const t1p1 = document.getElementById('t1p1');
        const t2p1 = document.getElementById('t2p1');
        const t3p1 = document.getElementById('t3p1');
        const t4p1 = document.getElementById('t4p1');
        t1p1.textContent = line1;
        t2p1.textContent = line2;
        t3p1.textContent = line3;
        t4p1.textContent = line4;
        t1p1.style.fontSize = fitFontSize(line1, box1, maxFonts.line1, 700, t1p1.style.fontFamily) + 'px';
        t2p1.style.fontSize = fitFontSize(line2, box1, maxFonts.line2, 600, t2p1.style.fontFamily) + 'px';
        t3p1.style.fontSize = fitFontSize(line3, box1, maxFonts.line3, 600, t3p1.style.fontFamily) + 'px';
        t4p1.style.fontSize = fitFontSize(line4, box1, maxFonts.line4, 600, t4p1.style.fontFamily) + 'px';

        // Preview 1 - 2
        const box12 = document.getElementById('box12');
        const t1p12 = document.getElementById('t1p12');
        const t2p12 = document.getElementById('t2p12');
        const t3p12 = document.getElementById('t3p12');
        const t4p12 = document.getElementById('t4p12');
        t1p12.textContent = line1;
        t2p12.textContent = line2;
        t3p12.textContent = line3;
        t4p12.textContent = line4;
        t1p12.style.fontSize = fitFontSize(line1, box12, maxFonts.line1, 700, t1p12.style.fontFamily) + 'px';
        t2p12.style.fontSize = fitFontSize(line2, box12, maxFonts.line2, 600, t2p12.style.fontFamily) + 'px';
        t3p12.style.fontSize = fitFontSize(line3, box12, maxFonts.line3, 600, t3p12.style.fontFamily) + 'px';
        t4p12.style.fontSize = fitFontSize(line4, box12, maxFonts.line4, 600, t4p12.style.fontFamily) + 'px';

        // Preview 1 - 3
        const box13 = document.getElementById('box13');
        const t1p13 = document.getElementById('t1p13');
        const t2p13 = document.getElementById('t2p13');
        const t3p13 = document.getElementById('t3p13');
        const t4p13 = document.getElementById('t4p13');
        t1p13.textContent = line1;
        t2p13.textContent = line2;
        t3p13.textContent = line3;
        t4p13.textContent = line4;
        t1p13.style.fontSize = fitFontSize(line1, box13, maxFonts.line1, 700, t1p13.style.fontFamily) + 'px';
        t2p13.style.fontSize = fitFontSize(line2, box13, maxFonts.line2, 600, t2p13.style.fontFamily) + 'px';
        t3p13.style.fontSize = fitFontSize(line3, box13, maxFonts.line3, 600, t3p13.style.fontFamily) + 'px';
        t4p13.style.fontSize = fitFontSize(line4, box13, maxFonts.line4, 600, t4p13.style.fontFamily) + 'px';
    }

    // Atualiza ao digitar
    in1.addEventListener('input', update);
    in2.addEventListener('input', update);
    in3.addEventListener('input', update);
    in4.addEventListener('input', update);

    // Troca de layout
    layouts.addEventListener('click', e => {
        const btn = e.target.closest('button'); //botão clicado
        if (!btn) return;
        layouts.querySelectorAll('button').forEach(b => b.classList.remove('unselected'));
        layouts.querySelectorAll('button').forEach(b => b.classList.remove('selected'));
        layouts.querySelectorAll('button').forEach(b => b.classList.add('unselected'));
        btn.classList.remove('unselected');
        btn.classList.add('selected');

        // pega a base do nome da imagem do preview
        const base = btn.getAttribute('data-src').replace(/-\d+\.png$/, '').replace(/^.*\/|\.png$/g, '');
        const color = btn.getAttribute('data-color');
        const shadowColor = btn.getAttribute('data-shadow-color');
        const font = btn.getAttribute('data-font');
        const shadow = btn.getAttribute('data-shadow'); // "0" ou "1"
        const origin = window.location.origin.includes("localhost") ? window.location.origin + "/sobreloja" : window.location.origin;

        // aplica fundo em cada preview com sufixo diferente ao selecionar o tema
        // Preview passo 1 - Tema
        document.querySelector('#box1 img.bg').src = `${origin}/designs/templates/${window.dist_id}/${base}-1.png`;
        // Preview passo 2 - Texto
        document.querySelector('#box12 img.bg').src = `${origin}/designs/templates/${window.dist_id}/${base}-1.png`;
        // Preview passo 3 - Confirmação
        document.querySelector('#box13 img.bg').src = `${origin}/designs/templates/${window.dist_id}/${base}-1.png`;

        // aplica cor e fonte
        document.querySelectorAll('.line-text').forEach(el => {
            el.style.color = color;
            el.style.fontFamily = font;
            el.style.textShadow = 'none';
            el.style.shadowColor = "none";
            if (shadow === "1") {
                // ligado
                el.style.textShadow = [
                    '-1px -1px 0 ' + shadowColor, '0 -1px 0 ' + shadowColor, '1px -1px 0 ' + shadowColor,
                    '-1px 0 0 ' + shadowColor, '1px 0 0 ' + shadowColor,
                    '-1px 1px 0 ' + shadowColor, '0 1px 0 ' + shadowColor, '1px 1px 0 ' + shadowColor
                ].join(', ');
            } else {
                // vazio ou sem atributo → default (sem contorno, ou o que você quiser)
                el.style.textShadow = 'none';
            }
        });

        update();
    });

    // Inicial
    window.addEventListener('load', update);

    window.addEventListener('load', () => {
        const btn = document.querySelector('#layouts button.selected');
        const src = btn.getAttribute('data-src');
        const base = src.replace(/-\d+\.png$/, '');
        const color = btn.getAttribute('data-color');
        const shadowColor = btn.getAttribute('data-shadow-color');
        const font = btn.getAttribute('data-font');
        const shadow = btn.getAttribute('data-shadow'); // "0" ou "1"

        // aplica fundo default ao preview ao carregar a tela
        // preview passo 1 - Temas
        document.querySelector('#box1 img.bg').src = `${base}-1.png`;

        // preview passo 2 - Texto
        document.querySelector('#box12 img.bg').src = `${base}-1.png`;

        // preview passo 3 - Confirmação
        document.querySelector('#box13 img.bg').src = `${base}-1.png`;

        // aplica cor e fonte iniciais
        document.querySelectorAll('.line-text').forEach(el => {
            el.style.color = color;
            el.style.fontFamily = font;
            if (shadow === "1") {
                // ligado
                el.style.textShadow = [
                    '-1px -1px 0 ' + shadowColor, '0 -1px 0 ' + shadowColor, '1px -1px 0 ' + shadowColor,
                    '-1px 0 0 ' + shadowColor, '1px 0 0 ' + shadowColor,
                    '-1px 1px 0 ' + shadowColor, '0 1px 0 ' + shadowColor, '1px 1px 0 ' + shadowColor
                ].join(', ');
            } else {
                // vazio ou sem atributo → default (sem contorno, ou o que você quiser)
                el.style.textShadow = 'none';
            }
        });
        update();

    });
    
    $("[data-tema]").slideUp("fast");
    $("[data-tema='1']").slideDown("fast");
    $("[data-tema='1']").trigger( "click" );
    boxes.forEach(id => {
        document.getElementById(id).style.visibility = 'visible';
    });
    update();
    
    $('[data-select]').on("click",(e) => {
        let item = e.target.getAttribute('data-select');
        $(".wrapper_tema").removeClass("selected").addClass("unselected");
        $(`#tema_${item}`).addClass("selected");
        $("[data-tema]").slideUp("fast");
        $(`[data-tema=${item}]`).slideDown("fast");
        update();
        document.querySelector(`[data-tema="${item}"]`).click();
    });


    document.querySelector('#accept').addEventListener("click", () => {
        $('#add_to_cart').toggle();
    });
    // ABAS
    document.querySelector('a[href="#abaEstilo"]').addEventListener("click", () => {
        update();
        $('#abaEstilo').slideDown("fast");
        $('#abaTema').slideUp("fast");
        $('#abaTexto').slideUp("fast");
        $('#abaConfirmacao').slideUp("fast");
        boxes.forEach(id => {
            document.getElementById(id).style.visibility = 'visible';
        });
    });

    document.querySelector('a[href="#abaTema"]').addEventListener("click", () => {
        update();
        $('#abaEstilo').slideUp("fast");
        $('#abaTema').slideDown("fast");
        $('#abaTexto').slideUp("fast");
        $('#abaConfirmacao').slideUp("fast");
        boxes.forEach(id => {
            document.getElementById(id).style.visibility = 'visible';
        });
    });

    document.querySelector('a[href="#abaTexto"]').addEventListener("click", () => {
        update();
        $('#abaEstilo').slideUp("fast");
        $('#abaTema').slideUp("fast");
        $('#abaTexto').slideDown("fast");
        $('#abaConfirmacao').slideUp("fast");
        boxes.forEach(id => {
            document.getElementById(id).style.visibility = 'visible';
        });
    });

    document.querySelector('a[href="#abaConfirmacao"]').addEventListener("click", () => {
        update();
        $('#abaEstilo').slideUp("fast");
        $('#abaTema').slideUp("fast");
        $('#abaTexto').slideUp("fast");
        $('#abaConfirmacao').slideDown("fast");
        boxes.forEach(id => {
            document.getElementById(id).style.visibility = 'visible';
        });
    });

    // BOTOES
    document.querySelector('#avancarTema').addEventListener("click", () => {
        update();
        $('#abaEstilo').slideUp("fast");
        $('#abaTema').slideDown("fast");
        $('#abaTexto').slideUp("fast");
        $('#abaConfirmacao').slideUp("fast");
        boxes.forEach(id => {
            document.getElementById(id).style.visibility = 'visible';
        });
    });
    
    document.querySelector('#voltarEstilo').addEventListener("click", () => {
        update();
        $('#abaEstilo').slideDown("fast");
        $('#abaTexto').slideUp("fast");
        $('#abaConfirmacao').slideUp("fast");
        $('#abaTema').slideUp("fast");
    });
    
    
    document.querySelector('#avancarTexto').addEventListener("click", () => {
        update();
        $('#abaEstilo').slideUp("fast");
        $('#abaTexto').slideDown("fast");
        $('#abaConfirmacao').slideUp("fast");
        $('#abaTema').slideUp("fast");
    });
    
    document.querySelector('#avancarConfirmacao').addEventListener("click", () => {
        update();
        $('#abaEstilo').slideUp("fast");
        $('#abaTexto').slideUp("fast");
        $('#abaConfirmacao').slideDown("fast");
        $('#abaTema').slideUp("fast");
    });
    
    document.querySelector('#voltarTema').addEventListener("click", () => {
        update();
        $('#abaEstilo').slideUp("fast");
        $('#abaTexto').slideUp("fast");
        $('#abaConfirmacao').slideUp("fast");
        $('#abaTema').slideDown("fast");
    });
    
    document.querySelector('#voltarTexto').addEventListener("click", () => {
        update();
        $('#abaEstilo').slideUp("fast");
        $('#abaTexto').slideDown("fast");
        $('#abaConfirmacao').slideUp("fast");
        $('#abaTema').slideUp("fast");
    });

    // Função que observa os grupos de previews
    const observeGroup = function (groupIds, callback) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // quando qualquer box do grupo fica visível
                    callback();
                }
            });
        }, { threshold: 0.3 }); // 30% visível já dispara

        groupIds.forEach(id => {
            const el = document.getElementById(id);
            if (el) observer.observe(el);
        });
    }

    // Grupo 1: box1–box4
    observeGroup(['box1'], () => {
        console.log('Grupo 1 visível');
        update(); // ou sua função existente
    });

    // Grupo 2: box12–box42
    observeGroup(['box12'], () => {
        console.log('Grupo 2 visível');
        update();
    });

    // Grupo 3: box13–box43
    observeGroup(['box13'], () => {
        console.log('Grupo 3 visível');
        update();
    });


    // pega parametros na url e atualiza em spans

    document.addEventListener("DOMContentLoaded", function () {
        const params = new URLSearchParams(window.location.search);
        const kitParam = params.get("kit"); // ex: "1-210676"

        if (kitParam) {
            const [kit, prid] = kitParam.split("-"); // separa em duas partes

            // exibe nos elementos desejados
            document.getElementById("kit-value").textContent = kit;
            //document.getElementById("prid-value").textContent = prid;
        } else {
            document.getElementById("kit-value").textContent = "não definido";
            //document.getElementById("prid-value").textContent = "não definido";
        }
    });

    // atualiza url das imagens nos boxes e botoes

    document.addEventListener("DOMContentLoaded", function () {
        const base = window.location.origin + "/designs/templates/"+window.dist_id;
        const buttons = document.querySelectorAll("#layouts button");

        buttons.forEach(btn => {
            // Pega o src atual (data-src) e extrai apenas o nome do arquivo
            const current = btn.getAttribute("data-src") || "";
            const filename = current.split("/").pop(); // ex: "4_Espaco-1.png"
            const newUrl = base + filename;

            // Atualiza data-src do botão
            btn.setAttribute("data-src", newUrl);

            // Atualiza a imagem interna <img>
            const img = btn.querySelector("img");
            if (img) {
                img.src = newUrl;
            }
        });
    });

    // atualiza escala quando muda desktop/mobile
    const mq = window.matchMedia("(max-width: 768px)");
    mq.addEventListener("change", () => {
        update();
    });

    //Deixa previews Hidden enquanto não carregou as imagens


    const carregarBackgroundsAntesDeExibir = function () {
        const promises = boxes.map(id => {
            const el = document.getElementById(id);
            const bg = window.getComputedStyle(el).backgroundImage;

            // extrai URL da imagem
            const match = bg.match(/url\(["']?(.*?)["']?\)/);
            if (!match || !match[1]) return Promise.resolve(); // sem imagem

            const url = match[1];
            return new Promise(resolve => {
                const img = new Image();
                img.onload = resolve;
                img.onerror = resolve; // mesmo erro conta como carregado
                img.src = url;
            });
        });

        // espera todas carregarem
        Promise.all(promises).then(() => {
            boxes.forEach(id => {
                document.getElementById(id).style.visibility = 'visible';
            });
        });
    }

    // inicialmente esconde os boxes
    boxes.forEach(id => {
        document.getElementById(id).style.visibility = 'hidden';
    });

    // chama quando a página estiver pronta
    window.addEventListener('load', carregarBackgroundsAntesDeExibir);

    // renderiza canvas e envia para carrinho

    window.imagens = [];

    const Design = {
        salvar: (in_imagens) => {
            let url = wp.ajax_url + "?action=sl_save_return_school";
            let params = new URLSearchParams(window.location.search);

            // monta FormData
            let formData = new FormData();
            formData.append('product_id', params.get('kit')); // atenção: products_id (igual ao PHP)

            // envia cada imagem como array simples
            in_imagens.forEach((img, i) => {
                // remove prefixo "data:image/jpeg;base64," para enviar só o base64 puro
                let cleanImg = img.replace(/^data:image\/jpeg;base64,/, '');
                formData.append('imagens[' + i + ']', cleanImg);
            });

            document.querySelector(".loader").style.display = "block";
            fetch(url, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(res => {
                    document.querySelector(".loader").style.display = "none";
                    if (res.redirect) {
                        console.table(res);
                        window.location.href = res.redirect; // REDIRECIONA PARA O CARRINHO
                    } else {
                        console.table(res); // ERRO
                    }
                });
        }
    };

    // exporta previews em jpg
    document.getElementById('exportBtn').addEventListener('click', () => {
        document.getElementById('exportBtn').style.display = 'none';
        const boxes = ['box13', 'box23', 'box33', 'box43'];

        // cria um array de promessas que já retornam base64
        const promises = boxes.map((id) => {
            const box = document.getElementById(id);
            return html2canvas(box, {
                scale: 4,
                useCORS: true
            }).then(canvas => {
                return canvas.toDataURL('image/jpeg', 0.9);
            });
        });

        // espera todas terminarem
        Promise.all(promises).then(imagesBase64 => {
            window.imagens = imagesBase64; // array de strings base64
            Design.salvar(window.imagens); // só chama aqui
        });
    });


    // atualiza url das imagens nos boxes e botoes

    document.addEventListener("DOMContentLoaded", function () {
        const base = window.location.origin + "/designs/templates/"+window.dist_id;
        const buttons = document.querySelectorAll("#layouts button");

        buttons.forEach(btn => {
            // Pega o src atual (data-src) e extrai apenas o nome do arquivo
            const current = btn.getAttribute("data-src") || "";
            const filename = current.split("/").pop(); // ex: "4_Espaco-1.png"
            const newUrl = base + filename;

            // Atualiza data-src do botão
            btn.setAttribute("data-src", newUrl);

            // Atualiza a imagem interna <img>
            const img = btn.querySelector("img");
            if (img) {
                img.src = newUrl;
            }
        });
    });


    // atualiza url das imagens nos boxes e botoes

    document.addEventListener("DOMContentLoaded", function () {
        const base = window.location.origin + "/designs/templates/" + window.dist_id + "/";
        const buttons = document.querySelectorAll("#layouts button");

        buttons.forEach(btn => {
            // Pega o src atual (data-src) e extrai apenas o nome do arquivo
            const current = btn.getAttribute("data-src") || "";
            const filename = current.split("/").pop(); // ex: "4_Espaco-1.png"
            const newUrl = base + filename;

            // Atualiza data-src do botão
            btn.setAttribute("data-src", newUrl);

            // Atualiza a imagem interna <img>
            const img = btn.querySelector("img");
            if (img) {
                img.src = newUrl;
            }
        });
    });

}
